import { useFormikSelectableSuboption } from '@/views';
import { useGetSubOptionsListQuery } from '@/redux';
import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { AddPersonalizationItemFormValue } from './PersonalizationItemFormContent';

export function useSelectableSuboption(
  selectedSubOptionIds?: string[],
  itemId?: string,
) {
  const formik = useFormikContext<AddPersonalizationItemFormValue>();

  const { currentData: suboptions } = useGetSubOptionsListQuery(
    {
      itemId: itemId!,
      includedUnlistedSuboptions: selectedSubOptionIds,
    },
    { skip: !itemId },
  );

  const selectableSuboption = useFormikSelectableSuboption('suboptionId');

  useEffect(() => {
    formik.setFieldValue('__hasSuboptions', !isEmpty(suboptions));

    if (formik.values.suboptionId) {
      return;
    }

    if (!isEmpty(suboptions) && suboptions!.length === 1) {
      formik.setFieldValue('suboptionId', suboptions!.at(0)!.id);
    } else if (isEmpty(selectedSubOptionIds)) {
      formik.setFieldValue('suboptionId', null);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suboptions]);

  return selectableSuboption;
}
